import config from 'devextreme/core/config';

const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImQzMmI1Y2RiLTcxMjktNDY4NS05YjZmLTVlMGM1ZDdjMTIxZSIsCiAgIm1heFZlcnNpb' +
  '25BbGxvd2VkIjogMjUyCn0=.qmk9gEBzNgv5Ty3KAIwJd5wU5ebk+f+zeG+1KB1MxBlyTBEpmjqoFwuzdzHb41ePFmFg5V5JqS2w07Z+AfqS1O2GZ' +
  'zfX8hLzpmnTkFd7WgiOD7npf2K30AuQQSppDfu9hOy5Xg==';

export const registerDxLicense = () => {
  config({ licenseKey });
};
